import { render, staticRenderFns } from "./Navbarpages.vue?vue&type=template&id=a9bc138a"
import script from "./Navbarpages.vue?vue&type=script&lang=js"
export * from "./Navbarpages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports